import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outlet-selection',
  templateUrl: './outlet-selection.component.html',
  styleUrls: ['./outlet-selection.component.scss']
})
export class OutletSelectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }



}
